const normalizePath = (p?: string | null): string => {
  if (!p) return ''
  let x = String(p).trim()
  if (!x.startsWith('/')) x = '/' + x
  if (x !== '/') x = x.replace(/\/+$/, '')
  return x.toLowerCase()
}

export const getCodeByRoutePath = (
  path: string,
  items: SidebarItem[]
): string | null => {
  const norm = normalizePath(path)
  const match = items.find((it) => normalizePath(it.link) === norm)
  return match ? match.code : null
}
